var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSend = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.073 19.48c-.355.96.648 1.86 1.563 1.401l15.74-7.87a1.129 1.129 0 0 0 0-2.018l-15.74-7.87c-.915-.458-1.918.442-1.563 1.401l2.08 5.613c.163.443.585.737 1.057.737h6.028a1.129 1.129 0 0 1 0 2.257H6.211c-.473 0-.895.294-1.059.736z",
  vectorEffect: "non-scaling-stroke"
})));
export default SvgSend;